import { Flex, Tag } from "@familyzone/component-library";
import React from "react";
import { UserAttributes as UserAttributesType } from "../../../types/Users";
import { YearAttributeEnum } from "../sis-integration/SisIntegration";
import { YEAR_LABELS } from "../sis-integration/AttributeConfig";

interface UserAttributesProps {
  attributes: UserAttributesType;
}

export const UserAttributes: React.FC<UserAttributesProps> = ({ attributes }) => {
  const renderAttributeTags = () => {
    const tags: JSX.Element[] = [];

    if (attributes.years) {
      attributes.years.forEach((year, index) => {
        const yearLabel = YEAR_LABELS[year as YearAttributeEnum];
        tags.push(
          <Flex key={`years-${index}`} mr="sp4" mb="sp4">
            <Tag data-testid={`attribute-${index}`} tagLabel={yearLabel} variant="brand" />
          </Flex>
        );
      });
    }

    return tags;
  };

  return (
    <Flex flexWrap="wrap" mb="sp24">
      {renderAttributeTags()}
    </Flex>
  );
};
